export enum LinkType {
  Pedagogical = 1,
  Lives = 2,
  MeetAcademico = 3,
  Others = 4,
}
